import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import '@fontsource-variable/inter';
import '@fontsource-variable/roboto-mono';
import '@svetoch/ui/tokens.css';
import '@svetoch/ui/styles.css';
import './styles.css';
import { App } from './app/App';
import { DATA_FRESHNESS_MS } from './shared/query-config';

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, staleTime: DATA_FRESHNESS_MS, refetchOnWindowFocus: false } }
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter><App /></BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
